/* eslint-disable unicorn/filename-case */
import { assertNever } from '@squareup/dex-utils-shared-assert-never';

import { PropertyCategory } from '../../../types';

export const useTableName = (propertyCategory: PropertyCategory): string => {
  switch (propertyCategory) {
    case PropertyCategory.ErrorDescriptions:
      return 'Error Descriptions';
    case PropertyCategory.EventPayload:
      return 'Event Payload';
    case PropertyCategory.PathParameters:
      return 'Path Parameters';
    case PropertyCategory.QueryParameters:
      return 'Query Parameters';
    case PropertyCategory.RequestBody:
      return 'Request Body';
    case PropertyCategory.ResponseFields:
      return 'Response Fields';
    case PropertyCategory.Definitions:
      return 'Definitions';
    default:
      return assertNever(propertyCategory);
  }
};
